import React, { memo, useCallback } from "react";

import { Button } from "components";
import { AddressSearchInputTexts } from "globalConstants";

import styles from "./addressSearchInput.module.scss";

type EmptyLabelProps = {
	text?: string;
	showEnterManuallyBtn?: boolean;
	isManualMode?: boolean;
	onClick?: (isManualMode: boolean) => void;
};

const EmptyLabel = ({
	text,
	showEnterManuallyBtn = false,
	isManualMode = false,
	onClick,
}: EmptyLabelProps) => {
	const onClickHandler = useCallback(() => {
		onClick?.(true);
	}, [onClick]);

	return (
		<div className={styles.emptyLabelContainer}>
			<div>{text || AddressSearchInputTexts.NoMatchesFound}</div>
			{showEnterManuallyBtn && (
				<Button
					value={AddressSearchInputTexts.EnterManually}
					onClick={onClickHandler}
					variant="secondary"
				/>
			)}
		</div>
	);
};

export default memo(EmptyLabel);
